var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1583 6.50003C15.9583 3.30003 11.5 2.13337 7.36667 2.98337L9.46667 5.08337C12.3583 4.9417 15.2917 5.95837 17.4917 8.1667L19.1583 6.50003ZM15.825 9.83337C14.75 8.75837 13.4583 8.05837 12.0833 7.70003L15.025 10.6417L15.825 9.83337ZM1.66667 1.5417L4.225 4.08337C3 4.68337 1.85 5.48337 0.833332 6.50003L2.49167 8.1667C3.525 7.13337 4.71667 6.3667 5.99167 5.85837L7.85833 7.72503C6.50833 8.07503 5.225 8.77503 4.16667 9.83337V9.8417L5.825 11.5C6.95833 10.3667 8.44167 9.80003 9.925 9.78337L15.8167 15.6667L16.875 14.6167L2.74167 0.491699L1.66667 1.5417ZM7.5 13.1667L10 15.6667L12.5 13.1667C11.125 11.7834 8.88333 11.7834 7.5 13.1667Z",
    fill: "#2196F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffLine);
export default __webpack_public_path__ + "static/media/off-line.9a2fbbaf2b6a6cb581133253fa9af7b2.svg";
export { ForwardRef as ReactComponent };